export const PROGRAM_SEARCH_TYPES = [
  { name: 'all',     text: 'All Programs', description: 'Search all career exploration, preparation, and on-the-job opportunities', },
  { name: 'explore', text: 'Explore',      description: 'Explore resources that provide early exposure to new jobs and industries', },
  { name: 'prep',    text: 'Prep',         description: 'Prepare with hands-on experience for a career track or industry', },
  { name: 'launch',  text: 'Launch',       description: 'Launch your career with high-quality on-the-job paid experience with aligned classroom learning', },
]

const allPerson = new URL('/src/images/all-person.png', import.meta.url)
const locationCircle = new URL('/src/images/location-circle.png', import.meta.url)

export const DEFAULT_MARKER_URL = allPerson.href;

export const MARKER_TYPES = [
  { result: 'location', location: '', url: locationCircle.href, },
     
  { result: 'arts', location: 'academic institution',     url: allPerson.href, },    
  { result: 'arts', location: 'academic partner institution', url: allPerson.href, },
  { result: 'arts', location: 'academic partner',  url: allPerson.href, },          
  { result: 'arts', location: 'class site', url: allPerson.href, },
  { result: 'arts', location: 'contact', url: allPerson.href, },
  { result: 'arts', location: 'employer',         url: allPerson.href, },            
  { result: 'arts', location: 'institution',  url: allPerson.href, },                 
  { result: 'arts', location: 'partner', url: allPerson.href, },
  { result: 'arts', location: 'program session',    url: allPerson.href, },          
  { result: 'arts', location: 'session',     url: allPerson.href, },          
  { result: 'arts', location: 'training agent',     url: allPerson.href, },          
  { result: 'arts', location: 'worksite', url: allPerson.href, },
    
  { result: 'launch', location: 'academic institution',     url: allPerson.href, },    
  { result: 'launch', location: 'academic partner institution', url: allPerson.href, },
  { result: 'launch', location: 'academic partner',  url: allPerson.href, },          
  { result: 'launch', location: 'class site', url: allPerson.href, },
  { result: 'launch', location: 'contact', url: allPerson.href, },
  { result: 'launch', location: 'employer',         url: allPerson.href, },            
  { result: 'launch', location: 'institution',  url: allPerson.href, },                 
  { result: 'launch', location: 'partner', url: allPerson.href, },
  { result: 'launch', location: 'program session',    url: allPerson.href, },          
  { result: 'launch', location: 'session',     url: allPerson.href, },          
  { result: 'launch', location: 'training agent',     url: allPerson.href, },          
  { result: 'launch', location: 'worksite', url: allPerson.href, },

  { result: 'cler', location: 'academic institution',     url: allPerson.href, },    
  { result: 'cler', location: 'academic partner institution', url: allPerson.href, },
  { result: 'cler', location: 'academic partner',  url: allPerson.href, },          
  { result: 'cler', location: 'class site', url: allPerson.href, },
  { result: 'cler', location: 'contact', url: allPerson.href, },
  { result: 'cler', location: 'employer',         url: allPerson.href, },            
  { result: 'cler', location: 'institution',  url: allPerson.href, },                 
  { result: 'cler', location: 'partner', url: allPerson.href, },
  { result: 'cler', location: 'program session',    url: allPerson.href, },          
  { result: 'cler', location: 'session',     url: allPerson.href, },          
  { result: 'cler', location: 'training agent',     url: allPerson.href, },          
  { result: 'cler', location: 'worksite', url: allPerson.href, },

  { result: 'learn', location: 'academic institution',     url: allPerson.href, },    
  { result: 'learn', location: 'academic partner institution', url: allPerson.href, },
  { result: 'learn', location: 'academic partner',  url: allPerson.href, },          
  { result: 'learn', location: 'class site', url: allPerson.href, },
  { result: 'learn', location: 'contact', url: allPerson.href, },
  { result: 'learn', location: 'employer',         url: allPerson.href, },            
  { result: 'learn', location: 'institution',  url: allPerson.href, },                 
  { result: 'learn', location: 'partner', url: allPerson.href, },
  { result: 'learn', location: 'program session',    url: allPerson.href, },          
  { result: 'learn', location: 'session',     url: allPerson.href, },          
  { result: 'learn', location: 'training agent',     url: allPerson.href, },          
  { result: 'learn', location: 'worksite', url: allPerson.href, },

  { result: 'searchfilter', location: 'searchfilter', url: locationCircle.href, },
]


export const PROGRAM_SEARCH_CAT_ID = {
  explore : 1,
  prep    : 2,
  launch  : 3,
}